export default "__VITE_ASSET__DqRZNTjj__"